import TaskFilters from "../../interfaces/task/TaskFilters";
import { appendTeamFilterParams } from "./taskFilterQueryParams";

/** One wire representation for the task list and its full-list PDF. */
export function buildTaskListQuery(filters: TaskFilters | null | undefined, sortBy = "", sortDesc = false,
  sortDescriptors: string[] = [], viewAll = false, includePendingApprovals = false, searchTerm?: string) {
  const queryParams = new URLSearchParams({ sortBy, sortDesc: String(sortDesc), viewAll: String(viewAll), includePendingApprovals: String(includePendingApprovals) });
  sortDescriptors.forEach(sort => queryParams.append("sort", sort));
    if (searchTerm) {
      queryParams.append("searchTerm", searchTerm);
    }

    // If we have filters, append them to queryParams
    // For arrays (e.g. status=Open&status=InProgress), we can do:
    if (filters) {
      if (filters.status && filters.status.length > 0) {
        filters.status.forEach((s) => queryParams.append("status", s));
      }
      if (filters.type && filters.type.length > 0) {
        filters.type.forEach((t) => queryParams.append("type", t));
      }
      if (filters.date && filters.date.length > 0) {
        filters.date.forEach((d) => queryParams.append("date", d));
      }
      if (filters.dateRangeStart) queryParams.set("dateRangeStart", filters.dateRangeStart);
      if (filters.dateRangeEnd) queryParams.set("dateRangeEnd", filters.dateRangeEnd);
      if (filters.assignees && filters.assignees.length > 0) {
        filters.assignees.forEach((a) => queryParams.append("assignee", a));
      }
      appendTeamFilterParams(queryParams, filters);
      if (filters.participants && filters.participants.length > 0) {
        filters.participants.forEach((p) =>
          queryParams.append("participant", p),
        );
      }
      if (filters.employeeSubjects && filters.employeeSubjects.length > 0) {
        filters.employeeSubjects.forEach((employeeId) =>
          queryParams.append("employeeSubject", employeeId),
        );
      }
      if (filters.tags && filters.tags.length > 0) {
        filters.tags.forEach((t) => queryParams.append("tags", t));
      }
      if (filters.excludeTags && filters.excludeTags.length > 0) {
        filters.excludeTags.forEach((t) =>
          queryParams.append("excludeTags", t),
        );
      }
      if (filters.excludeDate && filters.excludeDate.length > 0) {
        filters.excludeDate.forEach((d) =>
          queryParams.append("excludeDate", d),
        );
      }
      if (filters.excludeStatus && filters.excludeStatus.length > 0) {
        filters.excludeStatus.forEach((s) =>
          queryParams.append("excludeStatus", s),
        );
      }
      if (filters.excludeType && filters.excludeType.length > 0) {
        filters.excludeType.forEach((t) =>
          queryParams.append("excludeType", t),
        );
      }

      if (filters.automationIds && filters.automationIds.length > 0) {
        filters.automationIds.forEach((a) => queryParams.append("automation", a));
      }
      if (filters.excludeAutomationIds && filters.excludeAutomationIds.length > 0) {
        filters.excludeAutomationIds.forEach((a) => queryParams.append("excludeAutomation", a));
      }
      if (filters.taskDelayFilter && filters.taskDelayFilter !== "all") {
        queryParams.set("taskDelayFilter", filters.taskDelayFilter);
      }
      if (typeof filters.hasIssues === "boolean") {
        queryParams.set("hasIssues", String(filters.hasIssues));
      }
      if (filters.resourceFollowUpOnly === true) {
        queryParams.set("resourceFollowUpOnly", "true");
      }
      if (filters.taskContext) {
        queryParams.set("taskContext", filters.taskContext);
      }
      if (filters.leaveImpactEmployeeId && filters.leaveImpactStart &&
          filters.leaveImpactEnd && filters.leaveImpactAsOf) {
        queryParams.set("leaveImpactEmployeeId", filters.leaveImpactEmployeeId);
        queryParams.set("leaveImpactStart", filters.leaveImpactStart);
        queryParams.set("leaveImpactEnd", filters.leaveImpactEnd);
        queryParams.set("leaveImpactAsOf", filters.leaveImpactAsOf);
      }
    }

  return queryParams;
}
